export function buildOdooObligorLimitGroupPayload(model) {
  if (!model) {
    return {};
  }

  return {
      'alias_code': model.alias_code,
      'alias_name': model.alias_name,
  }
}
